import { useState, useEffect } from 'react';

const apiUrl = process.env.REACT_APP_AIRTABLE_PROPERTIES_URL;
const apiKey = process.env.REACT_APP_AIRTABLE_API_KEY;

function buildFilterFormula(purpose, filters = {}) {
  const clauses = [];
  if (purpose) clauses.push(`FIND("${purpose}", {Purpose})`);
  if (filters.minPrice) clauses.push(`{Starter price} >= ${filters.minPrice}`);
  if (filters.maxPrice) clauses.push(`{Starter price} <= ${filters.maxPrice}`);
  if (filters.bedrooms) clauses.push(`{Bedrooms} = ${filters.bedrooms}`);
  if (filters.bathrooms) clauses.push(`{Baths} = ${filters.bathrooms}`);
  if (filters.location) {
    const loc = filters.location.toLowerCase();
    clauses.push(
      `OR(SEARCH("${loc}", LOWER({City})), SEARCH("${loc}", LOWER({Address})))`
    );
  }
  if (filters.meters) clauses.push(`{Land m2} <= ${filters.meters}`);
  if (!clauses.length) return null;
  return `AND(${clauses.join(',')})`;
}

export default function useProperties({ purpose, filters = {}, offset }) {
  const [data, setData] = useState([]);
  const [nextOffset, setNextOffset] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams();
        params.append('pageSize', '21');
        if (offset) params.append('offset', offset);
        const formula = buildFilterFormula(purpose, filters);
        if (formula) params.append('filterByFormula', formula);
        const res = await fetch(`${apiUrl}?${params.toString()}`, {
          headers: { Authorization: `Bearer ${apiKey}` },
        });
        const json = await res.json();
        setData(json.records || []);
        setNextOffset(json.offset || null);
      } catch (err) {
        setError(err.message || 'Failed fetching properties');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [purpose, JSON.stringify(filters), offset]);

  return { data, nextOffset, loading, error };
}
